<template>
  <div class="legend-list">
    <LegendItem
      v-for="(item, index) in views"
      :key="index"
      :name="item[fields.legendName]"
      :color="item[fields.legendColor]"
    />
    <div v-if="data.length > 5" @click="isAll = !isAll" class="more-button">
      <span v-if="!isAll">{{ $t('查看更多') }}</span>
      <span v-else>{{ $t('收起') }}</span>
    </div>
  </div>
</template>

<script>
import LegendItem from './LegendItem.vue'
export default {
  components: { LegendItem },
  inject: ['theme'],
  props: {
    data: {
      type: Array,
      default: () => []
    },
    props: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isAll: false
    }
  },
  computed: {
    views() {
      return this.isAll ? this.data : this.data.slice(0, 4)
    },
    fields() {
      return {
        legendName: 'legendName',
        legendColor: 'legendColor',
        ...this.props
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.legend-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.more-button {
  padding-top: 14px;
  text-align: center;
  color: var(--font-color-3);
}
</style>
